import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { MDialog, ActionButtons } from "components/Shared";
import Button from "@mui/material/Button";
import RequirementsUploadDialog from "components/Customer/Profile/SurveyTypes/RequirementsUploadDialog";
import { getAppraiserOrderRequirements, deleteAppraiserOrderRequirements } from "actions/customerConfigurationAppraisal";
import { CustomerDetailsDto, AppraiserOrderRequirementsRetrieveResult, SurveyTypeListDto } from "interfaces/Mueller.Business.Models";

interface AppraisalRequirementsProps {
  // Redux
  selectedSurveyType: SurveyTypeListDto;
  customerDetails: CustomerDetailsDto;
  surveyTypeRequirements: AppraiserOrderRequirementsRetrieveResult;
  getAppraiserOrderRequirements: (customerNumber: number, surveyTypeCode: string) => void;
  deleteAppraiserOrderRequirements: (customerNumber: number, surveyTypeCode: string) => void;
}

const AppraisalRequirements = (props: AppraisalRequirementsProps) => {
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);

  useEffect(() => {
    props.getAppraiserOrderRequirements(props.customerDetails.number, props.selectedSurveyType.code);
  }, [props.selectedSurveyType, props.customerDetails]);

  // Dialogs

  const toggleDeleteConfirmDialog = () => setShowDeleteConfirmDialog(!showDeleteConfirmDialog);
  const toggleUploadDialog = () => setShowUploadDialog(!showUploadDialog);
  const deleteRequirements = () => {
    props.deleteAppraiserOrderRequirements(props.customerDetails.number, props.selectedSurveyType.code);
    toggleDeleteConfirmDialog();
  };
  const confirmDeleteDialogActions = [
    {onClick: () => deleteRequirements(), children: "Delete"},
    {onClick: toggleDeleteConfirmDialog, children: "Cancel"},
  ];

  // Render

  return (
    <>
      <div className="survey-type-requirements-container">
        <div>
          {props.surveyTypeRequirements?.pdfExists &&
          <>
            <a href={props.surveyTypeRequirements.pdfUrl} target="_blank">View current appraisal requirements</a>
            <Button color="secondary"
                onClick={toggleDeleteConfirmDialog}
            >
              Delete
            </Button>
          </>
          }
          {(!props.surveyTypeRequirements?.pdfExists) &&
            <p>No appraisal requirements pdf attached.</p>
          }
          <Button color="secondary"
              onClick={toggleUploadDialog}
          >
            Upload
          </Button>
        </div>
      </div>
      <RequirementsUploadDialog
          visible={showUploadDialog}
          surveyTypeCode={props.selectedSurveyType?.code}
          hideDialog={toggleUploadDialog}
      />
      <MDialog
          id="confirm-delete-survey-type-requirements"
          className="confirm-delete-survey-type-requirements"
          title="Confirm Delete"
          visible={showDeleteConfirmDialog}
          focusOnMount={false}
          width={525}
      >
        <p>Are you sure you want to delete this pdf? This action cannot be undone.</p>
        <ActionButtons buttonPropSets={confirmDeleteDialogActions}/>
      </MDialog>
    </>
  );
};

const mapStateToProps = state => ({
  selectedSurveyType: state.customer.selectedSurveyType,
  customerDetails: state.customer.customerDetails,
  surveyTypeRequirements: state.customer.surveyTypeRequirements,
});

const mapDispatchToProps = dispatch => ({
  getAppraiserOrderRequirements(customerNumber: number, surveyTypeCode: string) {
    dispatch(getAppraiserOrderRequirements(customerNumber, surveyTypeCode));
  },
  deleteAppraiserOrderRequirements(customerNumber: number, surveyTypeCode: string) {
    dispatch(deleteAppraiserOrderRequirements(customerNumber, surveyTypeCode));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppraisalRequirements);